/*
https://javascript-minifier.com/
*/

window._pendingErrors = [];
window.reportError = function () {
  window._pendingErrors.push(arguments);
};

var reportedErrors = {};

window.onerror = function (event, source, lineNumber, columnNumber, error) {
  if (reportedErrors === null) {
    return;
  }

  var data = {};
  // var seen = [];
  if (typeof event === 'string' && event !== null) {
    data.message = '!B! ' + event;
  } else {
    data.message =
      '!B! "type":"' +
      event['type'] +
      '" "returnValue":"' +
      event['returnValue'] +
      '" ' +
      JSON.stringify(Object.keys(event));
    /*data.message = '!B! ' + JSON.stringify(event, function(key, value) {
      if (value != null && typeof value == "object") {
        if (seen.indexOf(value) >= 0) {
          return;
        }
        seen.push(value);
      }
      return value;
    });*/
  }

  if (typeof source !== 'undefined' && source !== null) {
    data.url = source;
  }

  if (typeof lineNumber !== 'undefined' && lineNumber !== null) {
    data.line = lineNumber;
  }

  if (typeof columnNumber !== 'undefined' && columnNumber !== null) {
    data.col = columnNumber;
  }

  if (typeof error !== 'undefined' && error !== null) {
    data.error = error.toString();

    if (typeof error.stack !== 'undefined') {
      data.stack = error.stack;
    }
  }

  try {
    data.pageURL = window.location.href;
  } catch {
    //Sometimes I can't access it
  }

  if (typeof navigator !== 'undefined' && typeof navigator.userAgent !== 'undefined') {
    data.userAgent = navigator.userAgent;
  }

  if (!window.CCF || !window.CCF.LOADED) {
    setTimeout(function () {
      var isBot =
        window &&
        window.navigator &&
        typeof window.navigator.userAgent &&
        window.navigator.userAgent.toLocaleLowerCase().indexOf('googlebot') !== -1;

      var loadingEle = document.getElementById('siteLoading');
      if (loadingEle) {
        loadingEle.style.display = 'none';
      }

      var errorEle = document.getElementById('criticalError');
      if (errorEle && !isBot) {
        errorEle.innerHTML =
          "Something has gone critically wrong. You can try refreshing after awhile or contacting us <span id='email'></span> to know when it will be fixed.";
        errorEle.style.display = 'block';
      }

      var emailEle = document.getElementById('email');
      if (emailEle) {
        emailEle.innerHTML = 'info' + '@' + 'charlies' + 'chocolate' + 'factory.' + 'com';
      }
    }, 250);
  }

  var json = JSON.stringify(data); //TODO revamp this
  if (typeof reportedErrors[json] === 'undefined') {
    reportedErrors[json] = true;

    if (window.gtag) {
      window.gtag('event', 'exception', {
        description: data.message,
        fatal: true,
      });
    }

    var timesTried = 0;
    var sendData = function (jsonData) {
      timesTried++;
      var request = new XMLHttpRequest();
      request.open('POST', '/api/js_error.php');
      request.setRequestHeader('Content-type', 'application/json');
      request.onerror = function (e) {
        if (timesTried < 5) {
          setTimeout(function () {
            sendData(jsonData);
          }, 1000 * timesTried);
        } else {
          reportedErrors = null;
          throw e;
        }
      };
      setTimeout(function () {
        request.send(jsonData);
      }, 0);
    };

    sendData(json);
  }
};

/*
https://javascript-minifier.com/
*/

window.dataLayer = window.dataLayer || [];

function gtag() {
  window.dataLayer.push(arguments);
}

gtag('js', new Date());

(function (h, d) {
  h = h[d] = h[d] || {
    q: [],
    onReady: function (c) {
      h.q.push(c);
    },
  };
})(window, 'DD_RUM');

(function (h, d) {
  h = h[d] = h[d] || {
    q: [],
    onReady: function (c) {
      h.q.push(c);
    },
  };
})(window, 'DD_LOGS');

window.DD_LOGS.onReady(function () {
  window.DD_LOGS.init({
    clientToken: 'pub64e10d7c235dd5067a3cf4f6fcb25d39',
    site: 'us3.datadoghq.com',
    forwardErrorsToLogs: true,
    forwardReports: 'all',
    forwardConsoleLogs: 'all',
    useSecureSessionCookie: true,
    sessionSampleRate: 100,
    service: 'charlies-website',
    env: window['isDev'] ? 'dev' : 'prod',
  });
});
